const NAV_CONTENT_COLORS = {
  DEFAULT: 'default',
  SALE: 'sale',
  MEMBER_OFFER: 'memberOffer',
};

export default NAV_CONTENT_COLORS;
